// Regime-aware tax-vocabulary hook for admin reports / finance / settings.
//
// Single source for "what tax words does this tenant see?" — GST vs VAT,
// GSTIN vs TRN, split vs single line, and which India-only statutory surfaces
// (GSTR1 / Tally / HSN) are visible. Thin React wrapper over the
// framework-neutral `resolveTaxRegime()` in `@bbpos/ui` (the shared mirror of
// backend `tax-presentation.ts`), keyed off the tenant's immutable currency.
//
// Currency is immutable per tenant (mirrors `business_type`), so the result is
// stable for the session; `useMemo` keeps a stable reference across renders.
// An absent / unknown / legacy currency resolves to INR → GST_INDIA, keeping
// every existing tenant byte-identical to today.

import { useMemo } from 'react';
import { resolveTaxRegime } from '@bbpos/ui';
import type { TaxRegimePresentation } from '@bbpos/ui';

import { useTenantCurrency } from './use-tenant-currency';

/** Hook: the current tenant's regime-aware tax vocabulary. */
export function useTaxRegime(): TaxRegimePresentation {
  const currency = useTenantCurrency();
  return useMemo(() => resolveTaxRegime(currency), [currency]);
}
